/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Client_Portal_LinkedInputs */

const cs_client_portal_linked = /** @type {(inputs: Client_Portal_LinkedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Přístup do portálu je propojen s tímto klientem.`)
};

const en_client_portal_linked = /** @type {(inputs: Client_Portal_LinkedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Portal access is linked to this client.`)
};

/**
* | output |
* | --- |
* | "Portal access is linked to this client." |
*
* @param {Client_Portal_LinkedInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const client_portal_linked = /** @type {((inputs?: Client_Portal_LinkedInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Client_Portal_LinkedInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_client_portal_linked(inputs)
	return cs_client_portal_linked(inputs)
});